import { ResumeIcon } from "./icons/ResumeIcon";

const ResumeButton = (props) => {
  return (
    <div
      style={{
        position: "relative",
        width: "55px",
        height: "56px",
        border: "5px solid black",
        borderRadius: "10px",
        marginRight: "5px",
        cursor: "pointer",
      }}
      {...props}
    >
      <ResumeIcon />
    </div>
  );
};

export { ResumeButton };
